import { bimSelectedParamsAPI } from "@/views/BimSelectedParams/services/api";

export const getBimSelectedParams = async () => {
  try {
    const res = await bimSelectedParamsAPI.getList();
    return res?.data;
  } catch (e) {}
};

